module.exports = __webpack_public_path__ + "static/img/contacts-banner.d081831a.jpg";